export default "__VITE_ASSET__7R6TSg8O__"